import type { DocumentType, TagType } from "generated-graphql/graphql";

export const REVIEW_TABS = {
  DOCUMENT_DETAILS: "document-details",
  RELATED_TASKS: "related-tasks",
} as const;

export type ReviewTabValue = (typeof REVIEW_TABS)[keyof typeof REVIEW_TABS];

export type DocumentFacility = {
  id: string;
  name: string;
  customerFacilityId: string | null;
  streetAddress1: string | null;
  streetAddress2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
};

export type DocumentMetadataFormData = {
  documentTitle: string;
  documentType: DocumentType;
  dateAuthored: string | null;
  description: string;
  facilities?: DocumentFacility[];
  documentTags?: Array<{ id: string; name: string; type: TagType }>;
  documentSubtype: string;
  documentNumber: string;
  relatedDocumentNumber: string;
  revisionNumber: string;
  reportingPeriod: string;
  siteName: string;
  siteAddressLine1: string;
  siteAddressLine2: string;
  siteCity: string;
  siteState: string;
  siteZipCode: string;
  siteEmail: string;
  mailingName: string;
  mailingAddressLine1: string;
  mailingAddressLine2: string;
  mailingCity: string;
  mailingState: string;
  mailingZipCode: string;
  mailingEmail: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  contactAddressLine1: string;
  contactAddressLine2: string;
  contactCity: string;
  contactState: string;
  contactZipCode: string;
  agency: string;
  programArea: string;
  regulatoryProgram: string;
  regulatoryCitations: string;
  regulatoryAuthority: string;
  issueDate: string | null;
  expirationDate: string | null;
  effectiveDate: string | null;
  submissionDeadline: string | null;
  dueDate: string | null;
  amount: number | null;
  currency: string;
  relatedDocumentIds: string[];
  supersedes: string;
  summary: string;
  keywords: string[];
};

export type ReviewDocumentMetadataDialogProps = {
  open: boolean;
  onClose: () => void;
  documentIds: string[];
  tenantId: string;
  onComplete?: () => void;
  title?: string;
  hasDocumentAI?: boolean;
  onCurrentDocumentChange?: (documentId: string) => void;
};

export type SuggestedFacility = DocumentFacility;

export type TabSectionHandle = {
  /** Returns true if data was actually saved, false if skipped (no changes). */
  save: () => Promise<boolean>;
  isDirty: boolean;
};

export type ReviewTab = {
  value: ReviewTabValue;
  label: React.ReactNode;
  showPreview: boolean;
};
